module.exports = __webpack_public_path__ + "static/img/taozi.41ef6a54.png";